'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImagePickerControl = require('./ImagePickerControl');

var _ImagePickerControl2 = _interopRequireDefault(_ImagePickerControl);

var _NavigationBarControl = require('./NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectImage = function SelectImage(element, args) {
  var _this = this;

  _classCallCheck(this, SelectImage);

  var fragment = document.createDocumentFragment();

  new _NavigationBarControl2.default(fragment, {
    title: 'Kies afbeelding',
    leftHandButtons: [{
      onclick: function onclick() {
        if (args.oncancel) {
          window.removeEventListener('paste', _this.pasteHandler);
          args.oncancel();
        }
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        if (args.onok) {
          window.removeEventListener('paste', _this.pasteHandler);
          args.onok(_this.results.getImage());
        }
      },
      icon: '\uE11E'
    }],
    contextMenu: [{
      onclick: function onclick() {
        if (_this.select) {
          _this.select();
        }
      },
      icon: '\uE08D',
      label: 'Kies afbeelding'
    },
    /*{
        onclick: () => {
            if (this.rotate) {
                this.rotate()
            }
        },
        icon: '\ue0da',
        label: 'Afbeelding draaien'
    },*/
    {
      onclick: function onclick() {
        if (_this.clear) {
          _this.clear();
        }
      },
      icon: '\uE03D',
      label: 'Geen afbeelding'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport composer';

  this.results = new _ImagePickerControl2.default(div, { image: args.image });
  fragment.appendChild(div);

  this.select = this.results.onselect.bind(this.results);
  //this.rotate = this.results.onrotate.bind(this.results)
  this.clear = this.results.clearImage.bind(this.results);
  this.pasteHandler = this.results.pasteHandler.bind(this.results);

  window.addEventListener('paste', this.pasteHandler);

  element.appendChild(fragment);
};

exports.default = SelectImage;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/SelectImage.js
// module id = 38
// module chunks = 0